// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2PMLe","p":"_2epG2"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Noscript/Noscript.scss
 ** module id = 438
 ** module chunks = 0
 **/